import axios from "axios";
import { useMutation, useQuery } from "@tanstack/react-query";
import { API_BACKEND_URL } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const startPerformanceTest = async (payload = {}) => {
  const user = getUserDetails();

  const response = await axios.post(`${API_BACKEND_URL}/performance-tests/start`, payload, {
    headers: {
      token: user.token,
      companyId: user.companyid,
    },
  });

  return response.data;
};

export const useStartPerformanceTest = (options = {}) => {
  return useMutation({
    mutationFn: startPerformanceTest,
    ...options,
  });
};

const stopPerformanceTest = async ({ testRunId }) => {
  if (testRunId === undefined || testRunId === null) {
    throw new Error("testRunId is required to stop a performance test");
  }

  const user = getUserDetails();

  const response = await axios.post(
    `${API_BACKEND_URL}/performance-tests/${testRunId}/stop`,
    {},
    {
      headers: {
        token: user.token,
        companyId: user.companyid,
      },
    },
  );

  return response.data;
};

/** Cancels a suite's remaining queued runs as well as the one in progress. */
const stopPerformanceSuite = async ({ suiteId }) => {
  const user = getUserDetails();
  const response = await axios.post(
    `${API_BACKEND_URL}/performance-tests/suite/${suiteId}/stop`,
    {},
    { headers: { token: user.token, companyId: user.companyid } },
  );
  return response.data;
};

export const useStopPerformanceSuite = (options = {}) =>
  useMutation({ mutationFn: stopPerformanceSuite, ...options });

export const useStopPerformanceTest = (options = {}) => {
  return useMutation({
    mutationFn: stopPerformanceTest,
    ...options,
  });
};

const getPerformanceTestResults = async ({ url, testSuiteId }) => {
  /*  This api endpoint does two things:
  1. Fetch the performance test results for a test suite --> pass test suiteId
  2. FEtch performance test results for a single endpoint/test case --> pass the url.

  In case of test suite when we pass the testSuiteId and in case of endpoint we pass the url

  
  For Test Suite: It'll return an array of urls (endpoints)  and then to get the results for each endpoint 
  we need to call this same api endpoint but this time passing the url of the endpoint in the body as url . 




  TODO: NEED TO WORK ON PAGINATION, WHEN THE BACKEND SUPPORTS IT. 
  */

  let queryString = `testSuiteId=${testSuiteId}`;
  if (url) {
    queryString += `&url=${url}`;
  }

  const response = await axios.get(`${API_BACKEND_URL}/performance-tests/suite?${queryString}`);
  return response.data;
};

export const useGetPerformanceTestResults = (options = {}) => {
  return useQuery({
    queryKey: ["performanceTestResults", options],
    queryFn: () => getPerformanceTestResults(options),
    ...options,
  });
};
